





















import { Component, Vue } from 'vue-property-decorator'
import { EFriend } from '@/types/categories/friend'

@Component
export default class GameBoard extends Vue {
  get headers () {
    return ['receiver', ...this.categories]
  }

  get categories () {
    const categories = this.$store.getters['categories']
    return Object.keys(categories[0])
  }

  get friends () {
    return this.$store.getters['boardFriends']
  }

  protected friendCategory (friend: string, category: string) {
    return this.board[friend][category]
  }

  get board () {
    return this.$store.getters['board']
  }
}
